<template>
  <CSidebar
    fixed
    :minimize="minimize"
    :show="show"
    @update:show="(value) => $store.commit('set', ['sidebarShow', value])"
  >
    <CSidebarBrand class="d-md-down-none" to="/">
      <CIcon
        class="d-block"
        name="logo_new"
        size="custom-size"
        :height="35"
        :viewBox="`0 0 ${minimize ? 110 : 556} 134`"
      />
    </CSidebarBrand>
    <CRenderFunction flat :content-to-render="nav"/>
    <CSidebarMinimizer
      class="d-md-down-none"
      @click.native="$store.commit('set', ['sidebarMinimize', !minimize])"
    />
  </CSidebar>
</template>

<script>
import axios from 'axios'
export default {
  name: 'TheSidebar',
  data () {
    return {
      //minimize: false,
      nav: [],
      //show: true,
      buffor: [],
    }
  },
  computed: {
    show () {
      return this.$store.state.sidebarShow
    },
    minimize () {
      return this.$store.state.sidebarMinimize
    }
  },
  methods: {
    dropdown(data){
      let result = {
            _name: 'CSidebarNavDropdown',
            name: data['name'],
            route: data['href'],
            icon: data['icon'],
            _children: [],
      }
      for(let i=0; i<data['elements'].length; i++){
        if(data['elements'][i]['slug'] == 'dropdown'){
          result._children.push( this.dropdown(data['elements'][i]) );
        }else{
          result._children.push(
            {
                   _name:  'CSidebarNavItem',
                   name:   data['elements'][i]['name'],
                   to:     data['elements'][i]['href'],
                   icon:   data['elements'][i]['icon']
            }
          );
        }
      }
      return result;
    },
    rebuildData(data){
      this.buffor = [{
        _name: 'CSidebarNav',
        _children: []
      }];
      for(let k=0; k<data.length; k++){
        switch(data[k]['slug']){
          case 'link':
            if(data[k]['href'].indexOf('http') !== -1){
              this.buffor[0]._children.push(
                  {
                      _name: 'CSidebarNavItem',
                      name: data[k]['name'],
                      href: data[k]['href'],
                      icon: data[k]['icon'],
                      target: '_blank'
                  }
              );
            }else{
              this.buffor[0]._children.push(
                  {
                      _name: 'CSidebarNavItem',
                      name: data[k]['name'],
                      to:   data[k]['href'],
                      icon: data[k]['icon'],
                  }
              );
            }
          break;
          case 'title':
            this.buffor[0]._children.push(
              {
                _name: 'CSidebarNavTitle',
                _children: [data[k]['name']]
              }
            );
          break;
          case 'dropdown':
            this.buffor[0]._children.push( this.dropdown(data[k]) );
          break;
        }
      }
      return this.buffor;
    }
  },
  mounted () {
    this.$root.$on('toggle-sidebar', () => {
      const sidebarOpened = this.show === true || this.show === 'responsive'
      this.show = sidebarOpened ? false : 'responsive'
    })
    this.$root.$on('toggle-sidebar-mobile', () => {
      const sidebarClosed = this.show === 'responsive' || this.show === false
      this.show = sidebarClosed ? true : 'responsive'
    })
    let self = this;

    console.log(this.$apiAdress);

    let menuTzsci=[
      {
        "id": 1,
        "slug": "link",
        "name": "首頁",
        "href": "/indexTZ",
        "hasIcon": true,
        "icon": "cil-speedometer",
        "iconType": "coreui"
      },
      {
        "id": 50,
        "slug": "link",
        "name": "傷友資料",
        "href": "/MemberList",
        "hasIcon": true,
        "icon": "cil-account-logout",
        "iconType": "coreui"
      },
      {
        "id": 50,
        "slug": "link",
        "name": "個案互動記錄",
        "href": "/CaseMagList",
        "hasIcon": true,
        "icon": "cil-account-logout",
        "iconType": "coreui"
      },
      {
        "id": 2,
        "slug": "link",
        "name": "設定-風險評估問題",
        "href": "/AppContentQuestionList",
        "hasIcon": true,
        "icon": "cil-account-logout",
        "iconType": "coreui"
      },
      {
        "id": 3,
        "slug": "link",
        "name": "設定-衛教知識文章",
        "href": "/AppContentKBEdit",
        "hasIcon": true,
        "icon": "cil-account-logout",
        "iconType": "coreui"
      },
      {
        "id": 3,
        "slug": "link",
        "name": "設定-醫療網",
        "href": "/AppContentDoctorEdit",
        "hasIcon": true,
        "icon": "cil-account-logout",
        "iconType": "coreui"
      },
      {
        "id": 3,
        "slug": "link",
        "name": "設定-最新消息",
        "href": "/AppContentNewsEdit",
        "hasIcon": true,
        "icon": "cil-account-logout",
        "iconType": "coreui"
      },
      {
        "id": 51,
        "slug": "link",
        "name": "設定",
        "href": "/TZSetting",
        "hasIcon": true,
        "icon": "cil-layers",
        "iconType": "coreui"
      },
      {
        "id": 51,
        "slug": "link",
        "name": "變更密碼",
        "href": "/ChangePwd",
        "hasIcon": true,
        "icon": "cil-layers",
        "iconType": "coreui"
      },
      {
        "id": 52,
        "slug": "link",
        "name": "登出",
        "href": "/login",
        "hasIcon": true,
        "icon": "cil-layers",
        "iconType": "coreui"
      }
    ];

    let menuKianseng=[
      {
        "id": 1,
        "slug": "link",
        "name": "首頁內容",
        "href": "/indexEdit",
        "hasIcon": true,
        "icon": "cil-speedometer",
        "iconType": "coreui"
      },
      {
        "id": 2,
        "slug": "link",
        "name": "網頁內容",
        "href": "/contentCatalog",
        "hasIcon": true,
        "icon": "cil-account-logout",
        "iconType": "coreui"
      },
      {
        "id": 50,
        "slug": "link",
        "name": "網頁內容(歷史資料)",
        "href": "/contentArchiveCatalog",
        "hasIcon": true,
        "icon": "cil-account-logout",
        "iconType": "coreui"
      },
      {
        "id": 51,
        "slug": "link",
        "name": "設定",
        "href": "/setting",
        "hasIcon": true,
        "icon": "cil-layers",
        "iconType": "coreui"
      },
      {
        "id": 52,
        "slug": "link",
        "name": "登出",
        "href": "/login",
        "hasIcon": true,
        "icon": "cil-layers",
        "iconType": "coreui"
      }
    ];

    let menuCheckInClient=[
      {
        "id": 1,
        "slug": "link",
        "name": "首頁",
        "href": "/index",
        "hasIcon": true,
        "icon": "cil-speedometer",
        "iconType": "coreui"
      },
      // {
      //   "id": 1,
      //   "slug": "link",
      //   "name": "我的資料",
      //   "href": "/CheckInClientInfo",
      //   "hasIcon": true,
      //   "icon": "cil-speedometer",
      //   "iconType": "coreui"
      // },
      // {
      //   "id": 2,
      //   "slug": "link",
      //   "name": "Test",
      //   "href": "/m/219d795d-9d2e-42cd-978c-3ba4d3085ca7",
      //   "hasIcon": true,
      //   "icon": "cil-speedometer",
      //   "iconType": "coreui"
      // },
    ];

    let menuCheckInAdmin=[
      {
        "id": 1,
        "slug": "link",
        "name": "首頁",
        "href": "/CheckInAdminIndex",
        "hasIcon": true,
        "icon": "cil-speedometer",
        "iconType": "coreui"
      },
      {
        "id": 2,
        "slug": "link",
        "name": "活動管理",
        "href": "/CheckInAdminEventIndex",
        "hasIcon": true,
        "icon": "cil-account-logout",
        "iconType": "coreui"
      },
      {
        "id": 2,
        "slug": "link",
        "name": "活動參加人員名單管理",
        "href": "/CheckInAdminEventMemberListIndex",
        "hasIcon": true,
        "icon": "cil-account-logout",
        "iconType": "coreui"
      },
      // {
      //   "id": 50,
      //   "slug": "link",
      //   "name": "抽獎",
      //   "href": "/CheckInAdminGame",
      //   "hasIcon": true,
      //   "icon": "cil-account-logout",
      //   "iconType": "coreui"
      // },
      {
        "id": 52,
        "slug": "link",
        "name": "登出",
        "href": "/login",
        "hasIcon": true,
        "icon": "cil-layers",
        "iconType": "coreui"
      }
    ];

    if (process.env.VUE_APP_siteType==="kianseng"){
      self.nav=self.rebuildData(menuKianseng);
    }else if (process.env.VUE_APP_siteType==="tzSci"){
      self.nav=self.rebuildData(menuTzsci);
    }else if (process.env.VUE_APP_siteType==="checkInClient"){
      self.nav=self.rebuildData(menuCheckInClient);
    }else if (process.env.VUE_APP_siteType==="checkInAdmin"){
      self.nav=self.rebuildData(menuCheckInAdmin);
    }


    // axios.get( this.$apiAdress + '/api/menu?token=' + localStorage.getItem("api_token") )
    // .then(function (response) {
    //   debugger // eslint-disable-line
    //   self.nav = self.rebuildData(response.data);
    // }).catch(function (error) {
    //   console.log(error);
    //   self.$router.push({ path: '/login' });
    // });
  }
}
</script>
